import { IApplicationState } from '../../types/redux';

export function getBuilder(state: IApplicationState) {
  return state.developer.builder;
}
